import React, { useMemo } from "react";
import Chart from "components/charts/Chart";
import { palette } from "lib/chartTheme";

const AGE_RANGES = ["0-17", "18-24", "25-34", "35-44", "45-54", "55-64", "65+"];

const OPTIONS = {
  colors: [palette.sage],
  plotOptions: { bar: { borderRadius: 4, columnWidth: "70%" } },
  xaxis: { categories: AGE_RANGES },
  yaxis: { labels: { formatter: (val) => `${val}%` } },
  tooltip: { y: { formatter: (val) => `${val}%` } },
};

const AgeDistributionChart = ({ data }) => {
  const { series, empty } = useMemo(() => {
    const total = Object.values(data || {}).reduce((sum, val) => sum + (val || 0), 0);
    const percentages = AGE_RANGES.map((range) =>
      total > 0 ? Math.round(((data[range] || 0) / total) * 100) : 0
    );
    return { series: [{ name: "Percentage", data: percentages }], empty: total === 0 };
  }, [data]);

  return (
    <Chart
      type="bar"
      series={series}
      options={OPTIONS}
      height={300}
      empty={empty}
      emptyText="No age data yet"
    />
  );
};

export default AgeDistributionChart;
